<template>
    <transition name="fade">
        <div v-if="open">
            <slot></slot>
            <button type="button" class="close" @click="closeNotification">
                <span>&times;</span>
            </button>
        </div>
    </transition>
</template>

<script>
export default {
    data () {
        return {
            open: true
        }
    },
    methods: {
        closeNotification () {
            this.open = false
        }
    }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/element/Notification.vue